import "bootstrap/dist/css/bootstrap.min.css";
import "./vission.scss";

const Vission = () => {
  return (
      <div className="row vission-box">
        <div className="col-lg-5 col-md-12 pe-lg-5 px-md-0 vission-left-content">
          <h1 className="vission-left-heading">
            <span className="green"> “</span>Every small step we take today
            creates waves of change that reach far beyond tomorrow..
            <span className="green">”</span>
          </h1>
        </div>
        <div className="col-lg-5 col-md-12 px-lg-4 px-md-0 vission-right-box">
          <div className="viss">
            <h5>Our Vission</h5>
            <p>
              Our vision is to create a sustainable model that ensures
              nutritious daily meals for the destitute in Thanjavur and beyond. 
            </p>
          </div>
          <div className="miss">
            <h5>Our Mission</h5>
            <p>
              Our mission is to scale this initiative across Tamil Nadu while
              building pathways to support education for underprivileged
              communities shortly.
            </p>
          </div>
        </div>
    </div>
  );
};
export default Vission;
